export const DASHBOARD_API_URL = {
  GET_DASHBOARD_PAGING: 'dashboard/paging',
  GET_DASHBOARD_ID: 'dashboard/{{dashboard_id}}',
  DELETE_DASHBOARD: 'dashboard/{{dashboard_id}}',
  CREATE_DASHBOARD: 'dashboard',
  UPDATE_DASHBOARD: 'dashboard',
  GET_ALL_DASHBOARD: 'dashboard/all',
  CREATE_DASHBOARD_WIDGET: 'dashboard-widget',
  GET_DASHBOARD_WIDGET_BY_ID: 'dashboard-widget/{{widget_id}}',
  UPDATE_DASHBOARD_WIDGET: 'dashboard-widget',
  DELETE_DASHBOARD_WIDGET: 'dashboard-widget/{{widget_id}}',
};
